export enum ApiErrorCategory {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_REQUEST = 'INVALID_REQUEST',
  REQUEST_RETRIES_EXCEEDED = 'REQUEST_RETRIES_EXCEEDED',
}
